export const TagType = {
  LABEL: 'LABEL',
  STICKER: 'STICKER',
};

export const TagTarget = {
  ITEM: 'ITEM',
  TASK: 'TASK',
  PROJECT: 'PROJECT',
};

export const TagTypeList = [
  {
    label: 'Címke',
    value: TagType.LABEL,
  },
  {
    label: 'Matrica',
    value: TagType.STICKER,
  },
];

export const TagTargetList = [
  {
    label: 'Cikkek',
    value: TagTarget.ITEM,
  },
  {
    label: 'Feladatok',
    value: TagTarget.TASK,
  },
  {
    label: 'Projekt',
    value: TagTarget.PROJECT,
  },
];
